import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import Navbar from './components/NavBar';
import AgentListDashboard from './pages/AgentListDashboard';
import LoginPage from './pages/LoginPage';
import Sidebar from './components/SideBar';
import InvoiceAgents from './pages/InvoiceAgents';
import NewAgentViewerScreen from './pages/NewAgentViewerScreen1';
import ProcessedDocuments from './pages/ProcessedDocuments'
import '../src/App.css'; // or './App.css'
import ActivityDetailsScreen from './pages/InvoiceAgents/ActivityDetailsScreen';
import ToastAlert from './components/ToastAlert';
import { setupInterceptors } from './api/apiclient';
import LoadMyAgent from './pages/LoadMyAgent'
import { ToastContainer } from 'react-toastify';

const WrappedApp = () => {
  return (
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <App />
      </Router>
      </PersistGate>
      </Provider>
  );
};

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [toast, setToast] = useState({ open: false, message: "", severity: "info" });

  useEffect(() => {
    setupInterceptors((message, severity) => {
      setToast({ open: true, message, severity });
    });
  }, []);


  const newAccessToken = localStorage.getItem("access_token");
  //Adjust the path according to your store (maybe state.auth.token)
  // Token Checking & Redirect Logic
    useEffect(() => {
      if (!newAccessToken && location.pathname !== '/') {
        navigate('/');
      }
    }, [newAccessToken, location.pathname, navigate]);
  

  const showNavbar = location.pathname !== '/';

    // Listen for internet connectivity changes
    useEffect(() => {
      const handleOffline = () => returInternetAvailability("You are offline! Check your internet connection.", "error");
      const handleOnline = () => returInternetAvailability("Back online!", "success");
  
      window.addEventListener("offline", handleOffline);
      window.addEventListener("online", handleOnline);
  
      return () => {
        window.removeEventListener("offline", handleOffline);
        window.removeEventListener("online", handleOnline);
      };
    }, []);
  
    const returInternetAvailability = (message, severity)=>{
      setToast({ open: true, message, severity })
    }
  



  return (
    <>
      {showNavbar && <Navbar />}
      {showNavbar && <Sidebar />}
      <div
        style={{
          marginLeft: showNavbar ? '80px' : '0',
          padding: '20px',
          width: showNavbar ? 'calc(100% - 80px)' : '100%',
          marginTop: showNavbar ? '60px' : '0', // Add space for fixed Navbar
          overflowY: 'auto', // Make content scrollable
        }}
      >
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/agentSelection" element={<AgentListDashboard />} />
          <Route path="/invoiceAgents" element={<InvoiceAgents />} />
          <Route path='/ActivityDetailsScreen' element={<ActivityDetailsScreen/>}/>
          <Route path="/NewAgentViewerScreen" element={<NewAgentViewerScreen />} />
          <Route path="/ProcessedDocuments" element={<ProcessedDocuments/>}/>
          <Route path='/LoadMyAgent' element={<LoadMyAgent/>}/>
        </Routes>
        <ToastAlert
        open={toast.open}
        onClose={() => setToast({ ...toast, open: false })}
        message={toast.message}
        severity={toast.severity}
      />
      </div>
      <ToastContainer />
    </>
  );
};

export default WrappedApp;
